import React from "react";
import "../../styles/CustomTable.css";
import { FaEye } from "react-icons/fa";

const CustomTable = ({ columns, data, onViewAnswer }) => {
  return (
    <table className="custom-table">
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th key={index}>{column}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {columns.map((column, colIndex) => (
              <td key={colIndex} className={colIndex === 1 && "content-cell"}>
                <div dangerouslySetInnerHTML={{ __html: row[column] }} />

                {colIndex === 1 && (
                  <span className="eye-icon" onClick={() => onViewAnswer(row)}>
                    <FaEye />
                  </span>
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CustomTable;
